import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="border-y border-background-200/70 bg-background-100 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <SectionHeading
              kicker="FAQ"
              title="关于投稿，您可能想问"
              description="还有一些疑问没有解决？可以先去了解投稿方式，再选择最适合自己的匿名投稿渠道。"
            />
            <a
              href="#channels"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              查看投稿方式
              <i className="ri-arrow-right-line" />
            </a>
          </Reveal>

          <div className="lg:col-span-8">
            <ul className="border-t border-background-200/70">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={faq.q} className="border-b border-background-200/70">
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-6 py-6 text-left cursor-pointer"
                    >
                      <span className="font-heading text-base text-foreground-950 md:text-lg">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="max-w-2xl pb-6 pr-10 text-sm leading-relaxed text-foreground-600">
                          {faq.a}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}